export default __webpack_public_path__ + "876cffee5cc38214fa2d2ef942104037.png";